import React, { useCallback, useEffect, useState } from 'react';
import { Avatar, Tooltip } from 'flowbite-react';
import { Img } from 'react-image';
import { AssessmentCompanyType, InterviewedByType } from './DetailCard';
import { sendTrackingEvent } from 'src/utils/gtm';
import { useLocation } from 'react-router-dom';
import { BsLinkedin } from 'react-icons/bs';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import { UserCareerPathType } from 'types';

interface Props {
	title: string;
	companydata?: AssessmentCompanyType;
	data: InterviewedByType;
	showTrustedText?: boolean;
	isUsedInBanner?: boolean;
}
const InterviewedBy = ({ title, companydata, data, showTrustedText = false, isUsedInBanner = false }: Props) => {
	const location = useLocation();
	const { interviewerName, companyName, companyRole, linkedinLink } = data;
	const { meetingTitle, companyLogo, companyURL, companyTitle, position } = companydata || {};
	// const companyRoleString = `${companyName} I ${companyRole}`;
	const [avatarImg, setAvatarImg] = useState<string>('');

	const careerPathDisplayNames: { [key in UserCareerPathType]: string } = {
		[UserCareerPathType.SOFTWARE_DEVELOPMENT]: 'Software Development',
		[UserCareerPathType.DATA_ANALYTICS]: 'Data Analytics',
		[UserCareerPathType.SDET]: 'SDET',
		[UserCareerPathType.TECH_SUPPORT]: 'Tech Support',
		[UserCareerPathType.OPERATIONS]: 'Operations',
		[UserCareerPathType.BD_EXECUTIVE]: 'BD Executive',
		[UserCareerPathType.DEV_OPS]: 'DevOps',
		[UserCareerPathType.MATH_ANNOTATIONS_EXPERT]: 'Math Annotations Expert',
		[UserCareerPathType.SITE_RELIABILITY_ENGINEER]: 'Site Reliability Engineer',
		[UserCareerPathType.SALES]: 'Sales',
		[UserCareerPathType.PRODUCT]: 'Product',
		[UserCareerPathType.HUMAN_RESOURCES]: 'Human Resources',
		[UserCareerPathType.MARKETING]: 'Marketing',
		[UserCareerPathType.HASKELL]: 'Haskell',
		[UserCareerPathType.REACT_NATIVE]: 'React Native',
		[UserCareerPathType.AI_ENGINEER]: 'AI Engineer',
	};

	const formatPosition = (pos: UserCareerPathType) => {
		return careerPathDisplayNames[pos] || pos;
	};
	const assessmentCompanyRoleString = `${companyTitle} I ${formatPosition(position as UserCareerPathType)} `;
	const [maxLength, setMaxLength] = useState<number>(15);

	useEffect(() => {
		if (window.innerWidth < 960) {
			setMaxLength(20);
		} else {
			setMaxLength(25);
		}
	}, []);
	const generateAvatar = useCallback(async () => {
		const res = await generateCompanyLogoAvatarSrc(companyLogo || '', companyURL || '');
		setAvatarImg(res);
	}, [companyURL, companyLogo]);
	useEffect(() => {
		generateAvatar();
	}, [companyURL, companyLogo]);

	return (
		<div className="mb-6">
			{/* <div className="text-[#7777E7] dark:text-[#CDF] text-[10px] md:text-[12px] font-[400]">{title}</div> */}
			<div className="flex gap-2 items-center mt-1">
				{/* <div className="">
					<Avatar bordered={data.imgUrl ? true : false} img={data.imgUrl} rounded className="[&_img]:p-0" />
				</div> */}
				<div className="">
					{companydata && (
						<Avatar
							bordered={companydata.companyURL ? true : false}
							img={companydata.companyLogo ? companydata.companyLogo : avatarImg}
							rounded
							className="[&_img]:p-0"
						/>
					)}
				</div>
				<div className="">
					<div className="text-[#28293D] dark:text-white text-sm font-[700] flex gap-2 items-center leading-[24px]">
						<div className="w-max">
							{(meetingTitle ?? '').length > maxLength ? (
								<>
									<Tooltip
										onClick={e => {
											e.stopPropagation();
										}}
										content={meetingTitle}
									>
										<span
											onClick={e => {
												e.stopPropagation();
											}}
										>
											{(meetingTitle ?? '').substring(0, maxLength)}...
										</span>
									</Tooltip>
								</>
							) : (
								<>{meetingTitle}</>
							)}
						</div>
						{/* {linkedinLink ? (
							<BsLinkedin
								onClick={() => {
									isUsedInBanner &&
										sendTrackingEvent({
											event: 'dashboard_interviewer_linkedin',
											eventLabel: location.pathname,
										});
									window.open(linkedinLink, '_blank');
								}}
								className="cursor-pointer bg-white text-[#7777E7] rounded-[1px]"
								size={10}
							/>
						) : null} */}
					</div>
					<div className="w-max text-[#555770] dark:text-[#E4E4EB] text-xs">
						{assessmentCompanyRoleString.length > maxLength ? (
							<>
								<Tooltip
									onClick={e => {
										e.stopPropagation();
									}}
									content={assessmentCompanyRoleString}
								>
									<span
										onClick={e => {
											e.stopPropagation();
										}}
									>
										{assessmentCompanyRoleString.substring(0, maxLength)}...
									</span>
								</Tooltip>
							</>
						) : (
							<>{assessmentCompanyRoleString}</>
						)}
					</div>
				</div>
			</div>
			{showTrustedText ? (
				<div className="text-[10px] mt-[6px] flex gap-1 font-normal text-[#8F90A6] dark:text-[#C7C9D9] sm:hidden">
					Not attending would result in losing your{' '}
					<Img loading="lazy" src="/assets/verified-tag.svg" width="10" height="10" alt="verified_badge" />
				</div>
			) : null}
		</div>
	);
};

export default InterviewedBy;
